<template>
  <dashboard-widget title="CASKS" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardCasks')"
                      @delete="$emit('delete','DashboardCasks')"
                      @close="$emit('close')">
    <div :class="{'text-caption':!zoomed,'text-body':zoomed}" v-if="types.length!==0">Total {{total}} casks</div>
    <div v-if="types.length===0" class="mt-12 pa-12 text-center">No casks found</div>
    <div class="text-center">
      <div ref="chart" class="d-inline-block" :style="zoomed?'height:400px;width:420px':'height:230px;width:230px'"
            @click="disableTo ? '' : $router.push({name:'InventoryCasks'})"/>
    </div>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardCasks',
  props: {
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      types: [],
      total: 0,
      chart: null,
      options:  {chartArea:{height:'100%',width:'100%'},
                 fontSize:this.zoomed?12:10,
                 pieSliceText:'label',
                 legend:{ position: "none", alignment:'center', textStyle:{fontSize:10}}}
    }
  },
  watch: {
    dark() {
      this.draw();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['corechart']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.PieChart(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardCasks {
                                            caskCountByType {
                                              siteId,name,colour,count
                                            }
                                          }`, {});
      if (!results.error) {
        this.types = results.data.caskCountByType;
        if (this.types.length === 0)
          this.$refs.chart.style.display = 'none';
        this.draw();
      }
    },

    draw() {
      if (this.chart === null)
        return;

      const data = [['TYPE', 'COUNT']];
      this.options.colors = [];
      this.total = 0;
      this.types.forEach(t => {
        let datum = data.find(d => d[0] === t.name);
        if (!datum) {
          datum = [t.name,0];
          data.push(datum);
          this.options.colors.push(t.colour);
        }
        datum[1] += t.count;
        this.total += t.count;
      });
      const dataTable = window.google.visualization.arrayToDataTable(data);

      this.chart.draw(dataTable, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    }
  }
}
</script>